
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M137.926 133.381l116.355 116.261 148.09-147.968-21.156-21.138-126.934 126.829-95.2-95.122h74.045V80.536H106.192v126.829h31.733v-73.984zM0 416.563l.011-12.273.087-4.801c.137-7.576 1.571-19.486 7.507-33.036 3.403-7.659 7.473-14.478 12.372-20.685.632-.765 64.163-76.153 236.095-76.158 146.185-.011 200.017 30.393 235.896 76.096 4.795 6.021 8.876 12.817 12.396 20.671 5.957 13.644 7.391 25.535 7.553 33.093l.083 17.076c.012 8.199-6.061 14.898-13.545 14.898l-97.664.001c-7.485-.011-13.573-6.693-13.591-14.911l.032-65.923-8.165-2.077c-4.546-1.162-9.535-2.575-14.921-4.142-25.43-7.287-60.242-17.272-108.152-17.244-47.826-.013-82.585 9.949-107.946 17.209-5.477 1.571-10.485 3.002-15.099 4.169l-8.172 2.084.009 65.929c-.021 8.203-6.12 14.914-13.593 14.925l-97.633-.01C6.087 431.444 0 424.767 0 416.563z"}})])
          )
        }
      }
    